export const ADMINISTRATIVE_ROLES = [
  "super admin",
  "super admin +",
  "company admin",
];

export const isAdministrativeRole = (role) =>
  ADMINISTRATIVE_ROLES.includes(String(role || "").trim().toLowerCase());

export const getPasswordChecks = (value = "") => {
  const passwordChecks = {
    minLength: value.length >= 8,
    uppercase: /[A-Z]/.test(value),
    lowercase: /[a-z]/.test(value),
    number: /\d/.test(value),
    special: /[!@#$%^&*]/.test(value),
  };

  return passwordChecks;
};

export const isStrongPassword = (value) =>
  Object.values(getPasswordChecks(value)).every(Boolean);

export const isSigningRole = (role) =>
  String(role || "").trim().toLowerCase() === "signing user";

export const isSigningPassword = (value) => typeof value === "string" && value.length === 4 && /^[0-9]{4}$/.test(value);

export const normalizeSigningPassword = (value) =>
  String(value || "").replace(/[^0-9]/g, "").slice(0, 4);

export const filterSigningPasswordInput = (event) => {
  event.target.value = normalizeSigningPassword(event.target.value);
};
